"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_NEWS_DETAIL_TITLE = exports.DATA_SOLR_SUGGESTION_CONTAINER = exports.DATA_SOLR_SEARCH_HEADLINE = exports.DATA_SOLR_INPUT_SUGGEST = exports.DATA_SOLR_FORM = exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = exports.DATA_FORM_PAGE_TITLE_HIDDEN = exports.DATA_FORM_PAGE_TITLE = exports.DATA_FILEUPLOAD_CHOSEN_FILE = exports.DATA_FILEUPLOAD_INPUT = exports.DATA_FILEUPLOAD_WRAP = exports.DATA_FORM_FIELD_ERROR_TEXT = exports.DATA_FORM_FIELD_ERROR = exports.DATA_FORM_FIELD = exports.DATA_FORM_FIELD_WRAP = exports.DATA_FORM_SUBMIT_ICON = exports.DATA_FORM_SUBMIT_TEXT = exports.DATA_FORM_SUBMIT = exports.DATA_FORM = exports.DATA_CD_FRAME = exports.DATA_FLOATING_CTA = exports.DATA_KEYFIGURES_END = exports.DATA_KEYFIGURES_START = exports.DATA_KEYFIGURES_NUMBER = exports.DATA_KEYFIGURES = exports.DATA_FOOTER = exports.DATA_SUBMENU_CLOSE = exports.DATA_SUBMENU = exports.DATA_TOGGLE_SUBMENU = exports.DATA_NAV_LINK = exports.DATA_NAVBAR_COLLAPSE = exports.DATA_NAVBAR_TOGGLE = exports.DATA_NAVBAR = exports.DATA_STICKY_HEADER = exports.DATA_ACCORDION = exports.DATA_SLIDER = void 0;
// Splide Slider
exports.DATA_SLIDER = 'data-slider';
// Accordion
exports.DATA_ACCORDION = 'data-accordion';
// Sticky Header
exports.DATA_STICKY_HEADER = 'data-sticky-header';
// Menu Navigation
exports.DATA_NAVBAR = 'data-navbar';
exports.DATA_NAVBAR_TOGGLE = 'data-navbar-toggle';
exports.DATA_NAVBAR_COLLAPSE = 'data-navbar-collapse';
exports.DATA_NAV_LINK = 'data-nav-link';
exports.DATA_TOGGLE_SUBMENU = 'data-toggle-submenu';
exports.DATA_SUBMENU = 'data-submenu';
exports.DATA_SUBMENU_CLOSE = 'data-submenu-close';
// Footer
exports.DATA_FOOTER = 'data-footer';
// Keyfigures
exports.DATA_KEYFIGURES = 'data-keyfigures';
exports.DATA_KEYFIGURES_NUMBER = 'data-keyfigures-number';
exports.DATA_KEYFIGURES_START = 'data-keyfigures-start';
exports.DATA_KEYFIGURES_END = 'data-keyfigures-end';
// Floating CTA
exports.DATA_FLOATING_CTA = 'data-floating-cta';
// CD FRAME
exports.DATA_CD_FRAME = 'data-cd-frame';
// Forms
exports.DATA_FORM = 'data-form';
exports.DATA_FORM_SUBMIT = 'data-form-submit';
exports.DATA_FORM_SUBMIT_TEXT = 'data-form-submit-text';
exports.DATA_FORM_SUBMIT_ICON = 'data-form-submit-icon';
exports.DATA_FORM_FIELD_WRAP = 'data-form-field-wrap';
exports.DATA_FORM_FIELD = 'data-form-field';
exports.DATA_FORM_FIELD_ERROR = 'data-form-field-error';
exports.DATA_FORM_FIELD_ERROR_TEXT = 'data-form-field-error-text';
exports.DATA_FILEUPLOAD_WRAP = 'data-fileupload-wrap';
exports.DATA_FILEUPLOAD_INPUT = 'data-fileupload-input';
exports.DATA_FILEUPLOAD_CHOSEN_FILE = 'data-fileupload-chosen-file';
exports.DATA_FORM_PAGE_TITLE = 'data-form-page-title';
exports.DATA_FORM_PAGE_TITLE_HIDDEN = 'data-form-page-title-hidden';
// SOLR
exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = 'tx_solr[queryString]';
exports.DATA_SOLR_FORM = 'data-solr-form';
exports.DATA_SOLR_INPUT_SUGGEST = 'data-solr-input-suggest';
exports.DATA_SOLR_SEARCH_HEADLINE = 'data-solr-search-headline';
exports.DATA_SOLR_SUGGESTION_CONTAINER = 'data-solr-suggestion-container';
// News
exports.DATA_NEWS_DETAIL_TITLE = 'data-news-detail-title';
